import { createActionGroup, props, emptyProps } from "@ngrx/store";
import { ModalConfirmProps } from "../../shared/models/modal-confirm";
import { AlertProps } from "../../shared/models/alert-props";

export const SettingActions = createActionGroup({
  source: 'Settings',
  events: {
    'Open Spinner': emptyProps(),
    'Close Spinner': emptyProps(),
    'Open Modal': props<ModalConfirmProps>(),
    'Close Modal': emptyProps(),
    'Open Alert': props<AlertProps>(),
    'Close Alert': emptyProps()
  },
});